import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';
import { ROUTES, resolveBaseRoute } from './routes';

// Lazy load all course components
const CourseHome = LazyComponentWithSuspense(() => import('../pages/Courses/Home'));
const CourseCreator = LazyComponentWithSuspense(() => import('../pages/Courses/CreateUpdate/CourseCreator'));
// const CreateCourse = LazyComponentWithSuspense(() => import('../pages/Courses/CreateCourse'));
const CourseHomePage = LazyComponentWithSuspense(() => import('../pages/Courses/CourseHomePage'));
// const UpdateCourse = LazyComponentWithSuspense(() => import('../pages/Courses/CourseUpdate'));
const CourseUpload = LazyComponentWithSuspense(() => import('../pages/Courseupload/Courseupload'));
const CourseVideo = LazyComponentWithSuspense(() => import('../pages/Coursevideo/Coursevideo'));
const CourseEnrollmentManagement = LazyComponentWithSuspense(() => import('../pages/Courses/CourseEnrollmentManagement'));
const CourseEnrollmentDetails = LazyComponentWithSuspense(() => import('../pages/Courses/CourseEnrollmentDetails'));
const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));

export const CourseRoutes = () => {
  return (
    <Routes>
      <Route index element={<CourseHome/>} />
      <Route path={resolveBaseRoute(ROUTES.COURSE_CREATE)} element={<CourseCreator />} />
      <Route path={resolveBaseRoute(ROUTES.COURSE_UPDATE)} element={<CourseCreator />} />
      {/* <Route path={resolveBaseRoute(ROUTES.COURSE_CREATE)} element={<CreateCourse />} /> */}
      {/* <Route path={resolveBaseRoute(ROUTES.COURSE_UPDATE)} element={<UpdateCourse />} /> */}
      <Route path={resolveBaseRoute(ROUTES.COURSE_HOME)} element={<CourseHomePage />} />
      <Route path={resolveBaseRoute(ROUTES.COURSE_UPLOAD)} element={<CourseUpload />} />
      <Route path={resolveBaseRoute(ROUTES.COURSE_VIDEOS)} element={<CourseVideo />} />
      <Route path={resolveBaseRoute(ROUTES.COURSE_ENROLLMENT_MANAGEMENT)} element={<CourseEnrollmentManagement />} />
      <Route path={resolveBaseRoute(ROUTES.COURSE_ENROLLMENT_DETAILS)} element={<CourseEnrollmentDetails />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
